import * as React from 'react';
import { cn } from '@/utils/utils';

export interface TextareaProps extends React.ComponentProps<'textarea'> {
  showThreshold?: number;
}

const Textarea = ({ className, showThreshold, ...props }: TextareaProps) => {
  return (
    <div className="w-full relative">
      <textarea
        data-slot="textarea"
        className={cn(
          // No break-all: it splits normal words mid-word ("manguer / a.").
          // overflow-wrap:break-word (the browser default here) already wraps
          // unbreakable long strings without mangling ordinary text.
          'pb-4! border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        {...props}
      />
      {(!props.maxLength
        ? false
        : showThreshold
          ? (props.value ?? '').toString().length > showThreshold
          : true) && (
        <small
          className={cn(
            'absolute right-0 bottom-1 mr-3 bg-transparent! pointer-events-none text-muted-foreground text-xs',
            props.maxLength &&
              (props.value ?? '').toString().length >= props.maxLength &&
              'text-destructive'
          )}
        >
          {(props.value ?? '').toString().length} / {props.maxLength}
        </small>
      )}
    </div>
  );
};
Textarea.displayName = 'Textarea';

export { Textarea };
